import $store from '@/store'
import { Company } from '@/class/model/mdm/Company'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getOverseaAgentGradeByCode } from '../parameters/OverseaAgentGrade'
import { BillAddress } from '@/class/model/mdm/BillAddress'
import { cache } from '@/utils/cacheManager'

// cargo 原 ImportConstants 中的方法移至此处 因其他地方 应用避免 import 前未加载
export class ImportConstants {
  static salesOfficeCheck = false // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
  static userList = []
  static _job = null

  /**
   * @private
   * 保存提单地址
   */
  static saveBillAddress(job) {
    const addr = new BillAddress().fillDefaultValue()

    addr.partnerId = job.customerId
    addr.pod = job.destinationPortCode
    addr.lob = job.lob
    addr.officeId = $store.getters.currentOfficeId

    addr.shipperCode = job.shipperCode
    addr.consigneeCode = job.consigneeCode
    addr.notifyCode = job.notifyCode

    addr.shipperLine1 = job.shipperLine1
    addr.shipperLine2 = job.shipperLine2
    addr.shipperLine3 = job.shipperLine3
    addr.shipperLine4 = job.shipperLine4
    addr.shipperLine5 = job.shipperLine5
    addr.shipperLine6 = job.shipperLine6

    addr.consigneeLine1 = job.consigneeLine1
    addr.consigneeLine2 = job.consigneeLine2
    addr.consigneeLine3 = job.consigneeLine3
    addr.consigneeLine4 = job.consigneeLine4
    addr.consigneeLine5 = job.consigneeLine5
    addr.consigneeLine6 = job.consigneeLine6

    addr.notifyLine1 = job.notifyLine1
    addr.notifyLine2 = job.notifyLine2
    addr.notifyLine3 = job.notifyLine3
    addr.notifyLine4 = job.notifyLine4
    addr.notifyLine5 = job.notifyLine5
    addr.notifyLine6 = job.notifyLine6

    BillAddress.checkBillAddress(addr)
  }

  static async designationAgentWithSalesHandler(cmpId, job, salesOfficeCheck, userList) {
    this.salesOfficeCheck = salesOfficeCheck
    this.userList = userList
    this._job = job
    const _companyObj = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(cmpId))
    if (_companyObj) {
      const overseaAgentDetail = await new Company(_companyObj).getOverseaAgentDetail()
      this.loadOverSeaHandler(overseaAgentDetail)
    }
  }

  /**
   * 显示销售名称
   */
  static async loadOverSeaHandler(agent) {
    if (agent) {
      if (String(cache.config.get('ToExoSystem')) !== 'DLWL') {
        this._job.sales = -1
        if (this.salesOfficeCheck) {
          for (const obj of this.userList) {
            if (agent.owner === obj.userId && obj.active) {
              this._job.sales = agent.owner
            }
          }
        } else {
          this._job.sales = agent.owner
        }
      }

      // 添加指定货代理等级
      const overseaAgentGrade = getOverseaAgentGradeByCode(agent.grade)
      if (overseaAgentGrade) {
        this._job.agentLevel = overseaAgentGrade.chineseName
      }
    }
  }

  /**
 * 用于计算计费重量
 * 四舍五入
 * 空运体积和重量的换算是体积（立方米）/0.006=体积重量（公斤）
 * 体积重量大于实际重量时候，计费重量就是体积重量
 * 体积重量小于实际重量的时候，计费重量就是实际重量
 * 0.1《尾数《0.5，则应为进位到0.5
 * 0.5《尾数《1则应进位到1
 */
  static toFixed2(value, digits = 0) {
    const strValue = String(value)
    const dotIndex = strValue.indexOf('.')
    let total = 0
    let fixed = 0
    if (dotIndex > 0) {
      total = Number(strValue.substr(0, dotIndex))
      if (digits > 0) {
        fixed = '0.' + Number(strValue.substr(dotIndex + 1, digits))
      }
    } else {
      total = value
    }
    if (total !== 0) {
      if (fixed >= 0.1 && fixed <= 0.5) {
        total = total + 0.5
      } else if (fixed > 0.5) {
        total += 1
      }
    }
    return total.toFixed(2)
  }
}
